<script>
import vueCountryRegionSelect from 'vue-country-region-select';

const regions = vueCountryRegionSelect.RegionSelect.data().regions;

export default {
  name: 'RegionSelect',
  props: {
    country: String,
    region: String,
    defaultRegion: String,
    countryName: Boolean,
    whiteList: Array,
    blackList: Array,
    regionName: Boolean,
    className: String,
    shortCodeDropdown: Boolean,
    placeholder: {
      type: String,
      default: 'Select Region'
    },
    disablePlaceholder: {
      type: Boolean,
      default: false
    },
    removePlaceholder: {
      type: Boolean,
      default: false
    },
    usei18n: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shownRegions: [],
      ran: false
    };
  },
  mounted() {
    if (this.country) {
      this.getRegionWithCountry();
    } else {
      const fallback = this.countryName
        ? (this.defaultRegion || 'United States')
        : (this.defaultRegion || 'US');
      this.getRegionWithCountry(fallback);
    }
  },
  methods: {
    regionValue(place) {
      if (this.regionName) return place.name;
      return place.shortCode || place.name;
    },
    onChange(region) {
      this.$emit('input', region);
    },
    getRegionWithCountry(country) {
      country = country || this.country;
      const match = regions.find((elem) => {
        return this.countryName
          ? elem.countryName === country
          : elem.countryShortCode === country;
      });
      let countryRegions = match ? match.regions.slice() : [];
      if (this.$i18n && this.usei18n) {
        countryRegions = countryRegions.map((region) => {
          const localeRegion = Object.assign({}, region);
          localeRegion.name = this.$t(region.name);
          return localeRegion;
        });
        countryRegions.sort((a, b) => (a.name > b.name ? 1 : -1));
      }
      if (this.whiteList) {
        countryRegions = countryRegions.filter((region) => this.whiteList.includes(region.shortCode));
      }
      if (this.blackList) {
        countryRegions = countryRegions.filter((region) => !this.blackList.includes(region.shortCode));
      }
      this.shownRegions = countryRegions;
      if (this.disablePlaceholder && this.ran && this.shownRegions.length) {
        this.onChange(this.regionValue(this.shownRegions[0]));
      }
      if (this.removePlaceholder && this.shownRegions.length) {
        this.onChange(this.regionValue(this.shownRegions[0]));
      }
      this.ran = true;
    }
  },
  watch: {
    country(_country, oldVal) {
      if (oldVal !== '') {
        this.onChange('');
      }
      if (this.country) {
        this.getRegionWithCountry();
      } else {
        this.shownRegions = [];
      }
    }
  }
};
</script>

<template>
  <select :class="className" :value="region || ''" autocomplete="off" @change="onChange($event.target.value)">
    <option v-if="!disablePlaceholder && !removePlaceholder" value="">{{ placeholder }}</option>
    <option v-if="disablePlaceholder && !removePlaceholder" value="" disabled>{{ placeholder }}</option>
    <option
      v-for="(place, index) in shownRegions"
      :key="index"
      :value="regionValue(place)"
    >
      {{ shortCodeDropdown ? (place.shortCode || place.name) : place.name }}
    </option>
  </select>
</template>
